/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { CircularProgress, Stack, styled } from '@mui/material';
import React, { FC } from 'react';

type PageProgressProps = object;

const PageProgressRoot = styled(Stack, {
  name: 'PageProgress',
  slot: 'Root',
})(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: theme.palette.background.paper,
}));

const PageProgress: FC<PageProgressProps> = () => {
  return (
    <PageProgressRoot alignItems="center" justifyContent="center" data-testid="page-progress">
      <CircularProgress
        variant="determinate"
        sx={{ position: 'absolute', color: (theme) => theme.palette.grey[300] }}
        size={43}
        value={100}
        thickness={3}
      />
      <CircularProgress
        variant="indeterminate"
        sx={{ position: 'absolute' }}
        size={43}
        thickness={3}
      />
    </PageProgressRoot>
  );
};

export default PageProgress;
